
import Vue from "vue";

import Spinner from "@/components/Spinner.vue";

export default Vue.extend({
  name: "AuthLogoutRedirectPage",
  components: { Spinner },
  async created() {
    try {
      sessionStorage.clear();
      await (this as any).$dep.authUseCase.clearToken();
      await (this as any).$dep.authUseCase.login();
    } catch (error) {
      //
    }
  },
});
